export const ExperienceTimeline = () => {
    return (
      <div className="timeline-container experience">
        <h3 className="section-title">
          <span className="title-icon">💼</span>
          Professional Experience
        </h3>
        <div className="timeline">
          <div className="timeline-line"></div>

          <div className="timeline-item">
            <div className="timeline-dot"></div>
            <div className="timeline-card">
              <div className="card-header">
                <h4 className="role-title">Graduate Developer – SEFE Energy UK</h4>
                <span className="date-badge">September 2025 – Present</span>
              </div>
              <div className="card-content">
                <p>
                  Develop and maintain company's system by adding new feature or changing data sources.
                  Demonstrated problem-solving, user requirements analysis and teamwork skills.
                </p>
                <div className="tech-tags">
                  <span>Vue</span>
                  <span>ASP.NET</span>
                  <span>C#</span>
                </div>
              </div>
            </div>
          </div>
          
          <div className="timeline-item">
            <div className="timeline-dot"></div>
            <div className="timeline-card">
              <div className="card-header">
                <h4 className="role-title">Full Stack Web Developer – Byte Queens (Volunteer)</h4>
                <span className="date-badge">June 2024 – Present</span>
              </div>
              <div className="card-content">
                <p>
                  Developed a fully functional website using React, JavaScript, and Node.js.
                  Demonstrated problem-solving skills and user requirements analysis.
                </p>
                <div className="tech-tags">
                  <span>React</span>
                  <span>JavaScript</span>
                  <span>Node.js</span>
                </div>
              </div>
            </div>
          </div>

          <div className="timeline-item">
            <div className="timeline-dot"></div>
            <div className="timeline-card">
              <div className="card-header">
                <h4 className="role-title">Software Developer Assistant – Council House</h4>
                <span className="date-badge">May 2018 – June 2018</span>
              </div>
              <div className="card-content">
                <p>
                  Developed an NFC tag-reading application. Showcased teamwork and problem-solving skills.
                </p>
                <div className="tech-tags">
                  <span>NFC</span>
                  <span>Mobile Development</span>
                </div>
              </div>
            </div>
          </div>

          <div className="timeline-item">
            <div className="timeline-dot"></div>
            <div className="timeline-card">
              <div className="card-header">
                <h4 className="role-title">Website Developer – Council House</h4>
                <span className="date-badge">May 2018 – June 2018</span>
              </div>
              <div className="card-content">
                <p>
                  Built a functional website using Joomla. Led the project and coordinated teamwork.
                </p>
                <div className="tech-tags">
                  <span>Joomla</span>
                  <span>Web Development</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
};

// EducationTimeline.js
export const EducationTimeline = () => {
    return (
      <div className="timeline-container education">
        <h3 className="section-title">
          <span className="title-icon">🎓</span>
          Academic Background
        </h3>
        <div className="timeline">
          <div className="timeline-line"></div>
          
          <div className="timeline-item">
            <div className="timeline-dot academic"></div>
            <div className="timeline-card">
              <div className="card-header">
                <h4 className="degree-title">BSc Software Engineering</h4>
                <span className="institution">University of Leicester</span>
                <span className="date-badge">July 2025 Graduate</span>
              </div>
              <div className="card-content">
                <div className="grade-display">
                  <span className="grade-badge first-class">First Class Honours</span>
                  <span>Passed with 84.61% overall marks</span>
                </div>
              </div>
            </div>
          </div>

          <div className="timeline-item">
            <div className="timeline-dot academic"></div>
            <div className="timeline-card">
              <div className="card-header">
                <h4 className="degree-title">BTEC Level 3 National Extended Diploma in IT - D*D*D*</h4>
                <span className="institution">Sandwell College</span>
                <span className="date-badge">2020 – 2022</span>
              </div>
            </div>
          </div>

          <div className="timeline-item">
            <div className="timeline-dot academic"></div>
            <div className="timeline-card">
              <div className="card-header">
                <h4 className="degree-title">OCR Level 2 Diploma in IT User Skills</h4>
                <span className="institution">Sandwell College</span>
                <span className="date-badge">2019 – 2020</span>
              </div>
            </div>
          </div>

          <div className="timeline-item">
            <div className="timeline-dot academic"></div>
            <div className="timeline-card">
              <div className="card-header">
                <h4 className="degree-title">GCSEs</h4>
                <span className="institution">Sandwell College</span>
              </div>
              <div className="card-content">
                <div className="grades-grid">
                  <div className="grade-item">
                    <span className="subject">Mathematics</span>
                    <span className="grade">Grade 6</span>
                  </div>
                  <div className="grade-item">
                    <span className="subject">English</span>
                    <span className="grade">Grade 8</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
};